import styled from 'styled-components';
import { ButtonPrimary } from '@comeon/ui';

const ButtonRegister = styled(ButtonPrimary)`
	background-color: var(--button-register, rgba(var(--primary), 1));
	border-radius: var(--button-register-border-radius, 3px);
	color: var(--button-register-text, rgba(var(--primary), 1));
	padding: 10px 16px;
`;

export default ButtonRegister;
